/**
 *
 * Adds appropriate obsolete category names to the array.
 * Useful to support old job listings
 */

const synonyms: Record<string, string[]> = {
  Nachwuchskräfte: [
    'Auszubildende',
    'Praktikum',
    'Trainee',
    'Werkstudententätigkeit',
  ],
  'Einkauf & Handel': ['Einkauf', 'Handel'],
  Technik: ['Netzwirtschaft', 'Engineering'],
  Governance: ['Recht & Revision'],
  'Human Resources': ['Betriebsrat'],
  Informationstechnologie: ['Digitalisierung', 'Information Technology'],
  'Marketing & Kommunikation': ['Kommunikation', 'Marketing'],
  'Projekt- & Prozessmanagement': ['Projekt- und Prozessmanagement'],
  Services: ['Standortservices', 'Verwaltung'],
  'Umwelt-, Gesundheits- und Arbeitsschutz': ['Unternehmenssicherheit'],
  Unternehmenssteuerung: ['Finanzen', 'Controlling', 'Unternehmensentwicklung'],
  Vertrieb: ['Produktentwicklung'],
};

export const extendMainCategoriesBySynonyms = (
  categories: readonly string[]
): string[] => {
  return categories.reduce<string[]>((prev, cur) => {
    return [...prev, cur, ...(synonyms[cur] ?? [])];
  }, []);
};
